import { FC, ReactNode } from 'react';
import { Grid2 as Grid } from '@mui/material';
import { DashboardItemWithSections } from 'domain/shared/core/dashboard';
import { useDashboardCallbacks } from '../hooks/useDashboardCallbacks';
import { HEALTHCHECK_CONFIG, isPolishContractorByEmployeeType } from 'domain/shared/employee';
import { getStatusByMonths } from '../utils/getStatusByMonth';

interface EmployeeDashboardWrapperProps {
  children: ReactNode;
  bottomContent?: ReactNode;
}

const EmployeeDashboardExpandedItemWrapper: FC<EmployeeDashboardWrapperProps> = ({ children, bottomContent }) => {
  const { employeeData, menuOptions, handleFollowUpRemove, handleFollowUpUpdate } = useDashboardCallbacks();
  const isPolishContractor = isPolishContractorByEmployeeType(employeeData);

  return (
    <>
      <Grid container spacing={2} alignItems="flex-start">
        <Grid size={{ xs: 4 }}>{children}</Grid>
        <Grid size={{ xs: 8 }}>
          <DashboardItemWithSections
            item={{
              ...employeeData,
              id: employeeData.retentionRiskId,
            }}
            sectionsConfig={{
              followUps: { enabled: true, maxItems: 3, title: 'Follow-ups' },
              issues: { enabled: true, maxItems: 3, title: 'Issues', showSeverityColors: true },
              people: { enabled: true, title: 'Management', isOpenInNewTab: true },
              healthcheck: { enabled: !isPolishContractor, title: 'Healthcheck' },
            }}
            menuOptions={menuOptions}
            onFollowUpRemove={handleFollowUpRemove}
            onFollowUpUpdate={handleFollowUpUpdate}
            healthcheckStatusConfig={HEALTHCHECK_CONFIG}
            healthcheckGetStatusByMonths={getStatusByMonths}
          />
        </Grid>
      </Grid>
      {bottomContent && (
        <Grid container sx={{ mt: 2 }}>
          <Grid size={{ xs: 12 }}>{bottomContent}</Grid>
        </Grid>
      )}
    </>
  );
};

export default EmployeeDashboardExpandedItemWrapper;
